var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreateApiConnection = function SvgCreateApiConnection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient);\n        opacity: .25;\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 99.89,
    y1: 69.05,
    x2: 34.92,
    y2: 149.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 132.92,
    y1: 3.99,
    x2: 23.27,
    y2: 151.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 127.07,
    y1: -0.37,
    x2: 17.42,
    y2: 146.91,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 182.18,
    y1: 40.66,
    x2: 72.53,
    y2: 187.94,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 159.48,
    y1: 23.76,
    x2: 49.83,
    y2: 171.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 182.96,
    y1: 41.24,
    x2: 73.31,
    y2: 188.52,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 185.95,
    y1: 43.47,
    x2: 76.3,
    y2: 190.75,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 141.83,
    y1: 10.62,
    x2: 32.17,
    y2: 157.9,
    xlinkHref: "#linear-gradient-2"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 74.86,
    cy: 100,
    r: 52.09
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.04,71.43c3.68-1.5,7.61-2.27,11.58-2.27,1.37,0,2.49-1.11,2.49-2.49s-1.11-2.49-2.49-2.49c-19.62.21-35.42,16.18-35.42,35.8s15.8,35.59,35.42,35.8c1.37,0,2.49-1.11,2.49-2.49s-1.11-2.49-2.49-2.49c-14.75,0-27.42-10.45-30.25-24.92-2.82-14.47,5-28.92,18.66-34.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2.02,113.2l8.96,3.03c1.53,5.37,3.77,10.52,6.67,15.29l-3.9,8.71c-.43.95-.21,2.07.53,2.8l14.02,13.67c.76.74,1.89.92,2.84.45l8.58-4.24c4.84,2.8,10.08,4.87,15.53,6.13l3.33,8.94c.36.98,1.29,1.62,2.33,1.62h.04l8.71-.15c1.38-.02,2.47-1.16,2.45-2.53-.02-1.38-1.16-2.47-2.53-2.45l-6.95.12-3.18-8.56c-.3-.81-.99-1.4-1.83-1.57-5.83-1.2-11.41-3.4-16.48-6.5-.73-.45-1.64-.49-2.4-.11l-8.21,4.06-11.51-11.23,3.73-8.33c.34-.76.28-1.65-.17-2.35-3.21-5.04-5.61-10.55-7.12-16.33-.21-.81-.82-1.46-1.61-1.73l-8.55-2.89-.27-16.05,8.56-3.18c.81-.3,1.4-.99,1.57-1.83,1.2-5.83,3.4-11.41,6.5-16.48.45-.73.49-1.64.11-2.4l-4.06-8.21,11.23-11.51,8.33,3.73c.76.34,1.65.28,2.35-.17,5.04-3.21,10.55-5.61,16.33-7.12.81-.21,1.46-.82,1.73-1.61l2.9-8.55,9.1-.15c1.38-.02,2.47-1.16,2.45-2.53-.02-1.37-1.16-2.47-2.53-2.45l-10.85.18c-1.05.02-1.98.7-2.32,1.69l-3.04,8.96c-5.37,1.53-10.51,3.77-15.29,6.67l-8.71-3.91c-.95-.43-2.07-.21-2.8.53l-13.67,14.01c-.74.76-.92,1.89-.45,2.84l4.24,8.58c-2.8,4.84-4.87,10.08-6.13,15.53l-8.94,3.32c-.99.37-1.64,1.32-1.62,2.38l.33,19.57c.02,1.05.7,1.98,1.69,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.63,97.5v4.98h99.32c1.28,6.65,7.41,11.24,14.16,10.6,6.75-.65,11.9-6.31,11.9-13.08s-5.15-12.44-11.9-13.08c-6.74-.65-12.87,3.94-14.16,10.6h-99.32ZM181.07,94.22c3.18-3.18,8.35-3.18,11.53,0,3.18,3.18,3.18,8.35,0,11.53-3.18,3.18-8.35,3.18-11.53,0-3.18-3.19-3.18-8.34,0-11.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.8,51.5c-6.29,0-11.7,4.46-12.9,10.64h-20.97c-7.36,0-13.32,5.97-13.33,13.33,0,4.61-3.74,8.35-8.35,8.35h-22.63v4.98h22.63c7.36,0,13.32-5.97,13.33-13.33,0-4.61,3.74-8.35,8.35-8.35h20.97c1.31,6.8,7.69,11.42,14.56,10.54,6.87-.88,11.88-6.94,11.44-13.86-.44-6.92-6.18-12.3-13.11-12.3ZM158.57,70.4c-3.18,3.18-8.34,3.18-11.52,0-3.18-3.18-3.18-8.34,0-11.52,3.18-3.18,8.34-3.18,11.52,0,3.18,3.19,3.18,8.35,0,11.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M152.8,148.47c6.93,0,12.66-5.39,13.1-12.3.44-6.91-4.57-12.98-11.44-13.86s-13.24,3.73-14.56,10.53h-20.97c-4.61,0-8.35-3.74-8.35-8.35,0-7.36-5.97-13.32-13.33-13.33h-22.63v4.98h22.63c4.61,0,8.35,3.74,8.35,8.35,0,7.36,5.97,13.32,13.33,13.33h20.97c1.2,6.18,6.6,10.64,12.9,10.64ZM147.04,129.57c3.18-3.18,8.35-3.18,11.53,0,3.18,3.18,3.18,8.35,0,11.53s-8.35,3.18-11.53,0c-1.53-1.53-2.4-3.6-2.4-5.77,0-2.17.86-4.24,2.4-5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.77,154.55c-2.16,2.15-3.5,4.99-3.79,8.02h-2.82c-4.66-.01-8.83-2.92-10.47-7.29l-7.05-19.04c-2.36-6.32-8.39-10.51-15.14-10.53h-6.88v4.98h6.88c4.67.01,8.84,2.92,10.47,7.28l7.05,19.04c2.36,6.32,8.39,10.52,15.14,10.54h3.29c1.67,5.68,6.93,9.53,12.84,9.43,5.92-.11,11.03-4.16,12.49-9.89,1.46-5.73-1.09-11.73-6.23-14.66-5.14-2.93-11.6-2.06-15.79,2.13h0ZM138.21,163.83c0,3.89-2.75,7.23-6.56,7.99-3.81.76-7.63-1.28-9.12-4.87-1.49-3.59-.23-7.73,3-9.89,3.23-2.16,7.54-1.74,10.29,1.01,1.53,1.53,2.4,3.6,2.39,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96.64,63.73l7.05-19.04c1.63-4.37,5.8-7.27,10.47-7.29h2.82c.66,6.72,6.31,11.84,13.06,11.82,6.75,0,12.38-5.15,13.02-11.87.64-6.72-3.93-12.82-10.56-14.1-6.63-1.28-13.14,2.69-15.05,9.16h-3.29c-6.75.02-12.78,4.22-15.14,10.54l-7.05,19.04c-1.63,4.37-5.8,7.27-10.47,7.28h-6.88v4.98h6.88c6.75-.02,12.78-4.22,15.14-10.53ZM124.29,30.37c2.75-2.75,7.06-3.17,10.29-1.01,3.23,2.16,4.49,6.31,3,9.9-1.49,3.59-5.31,5.64-9.12,4.88-3.81-.76-6.56-4.11-6.56-8,0-2.16.86-4.24,2.39-5.76h0Z"
  }))));
};
export default SvgCreateApiConnection;